export default "__VITE_ASSET__fae8a4a6__"